import { apiClient } from "./apiClient";

export const getEvents = async (countryCode: string, storeKey: string) => {
    try {
        console.log("=== API SERVICE [getEvents] LLAMADA ===");
        console.log("Parámetros enviados al backend:", { countryCode, storeKey });

        const response = await apiClient.post(`/events/get/getEventsToStore`, {
            storeKey: storeKey,
            countryCode: countryCode
        });

        console.log("Respuesta completa del backend (response.data):", response.data);
        console.log("Datos de eventos (response.data.data):", response.data?.data);

        return response.data.data;
    } catch (error) {
        console.error("Error en servicio getEvents:", error);
        return { status: 500 };
    }
}

export const getAdminCostToStore = async (token?: string, storeKey?: string) => {
    try {
        const response = await apiClient.post(`/events/get/getAdminCostStore`, {
            token: token,
            data: { storeKey: storeKey }
        });
        return response.data?.data;
    } catch (error) {
        return null;
    }
}

export const finishEvent = async (token: string, templateKey: string, chartsSelected: string[], option: string) => {
    try {
        const response = await apiClient.post(`/events/get/reservedSeats`, {
            token: token,
            eventSeatKey: templateKey,
            zoneSelected: chartsSelected,
            option: option
        });
        return response.data?.data;
    } catch (error) {
        return null;
    }
}

// =========================================================================================
// =========================================================================================
// ⚙️ SWITCH CENTRALIZADO DE SIMULACIÓN
// =========================================================================================
// false -> Llama directamente al endpoint real del backend (https://reports.barlleno.app/service/coupons/get/couponsForBines).
// true  -> Retorna datos ficticios de prueba localmente sin llamar al backend.
export const USE_MOCK_CARD_DISCOUNT = false;

export interface CardDiscountResponse {
    active: boolean;
    appliesTo?: 'ticket' | 'total' | 'hotdog' | string;
    discountType?: 'percentage' | 'fixed';
    discountPercentage?: number;
    discountAmount?: number;
    title?: string;
    description?: string;
    code?: string;
    bin?: string;
    country?: string;
    bank?: string;
    rawCoupon?: any;
    [key: string]: any;
}

export const checkCardDiscountService = async (
    bin: string,
    country: string,
    token?: string,
    eventId?: string
): Promise<CardDiscountResponse | null> => {
    const cleanBin = (bin || '').replace(/\D/g, '').slice(0, 6);
    const countryCode = country || 'RAF';

    console.log(`💳 [checkCardDiscountService] Modo: [${USE_MOCK_CARD_DISCOUNT ? 'SIMULACIÓN LOCAL' : 'ENDPOINT REAL'}]`, {
        bin: cleanBin,
        countryCode: countryCode,
        token: token,
        eventId: eventId,
    });

    if (!cleanBin || cleanBin.length < 6) {
        console.warn("⚠️ [checkCardDiscountService] El BIN proporcionado tiene menos de 6 dígitos numéricos.");
        return null;
    }

    // 1. MODO REAL: Llama directamente al endpoint proporcionado por backend
    if (!USE_MOCK_CARD_DISCOUNT) {
        try {
            const payload = {
                token: token || '',
                data: {
                    countryCode: countryCode,
                    cardBins: cleanBin
                }
            };

            console.log("🚀 [checkCardDiscountService] Enviando petición a https://reports.barlleno.app/service/coupons/get/couponsForBines:", payload);

            const response = await apiClient.post('https://reports.barlleno.app/service/coupons/get/couponsForBines', payload);

            console.log("📥 [checkCardDiscountService] Respuesta completa del backend:", response.data);

            const resData = response.data?.data;
            const coupon = resData?.coupon || resData?.coupons;

            if (!resData || !coupon) {
                console.log("ℹ️ [checkCardDiscountService] No hay cupones/descuentos disponibles para este BIN (coupon es null o no existe).");
                return null;
            }

            // Extracción de porcentaje y montos considerando todos los formatos del backend
            const percentage = Number(
                coupon.discount_percentage ||
                coupon.percentage ||
                coupon.discountPercentage ||
                (coupon.benefit_type === 'discount' ? coupon.discount : 0) ||
                0
            );

            const amount = Number(
                coupon.discount ||
                coupon.amount ||
                coupon.discountAmount ||
                0
            );

            const maxDiscount = Number(coupon.discount_max || 0);

            const bankName = (resData?.names_of_active_banks && resData.names_of_active_banks.length > 0)
                ? resData.names_of_active_banks.join(', ')
                : (coupon.bank || coupon.bankName || "");

            return {
                active: coupon.available !== false,
                appliesTo: 'ticket',
                discountType: percentage > 0 ? 'percentage' : (amount > 0 ? 'fixed' : (coupon.type || 'bin_price')),
                discountPercentage: percentage,
                discountAmount: amount,
                discountMax: maxDiscount,
                benefitType: coupon.benefit_type || 'discount',
                applyDiscount: coupon.applyDiscount !== false,
                title: coupon.title || coupon.name || coupon.couponName || `Promoción ${coupon.code || ''}`.trim(),
                description: coupon.info_txt || coupon.description || (coupon.code ? `Cupón ${coupon.code}` : ""),
                code: coupon.code || coupon.couponCode || "",
                bin: cleanBin,
                country: countryCode,
                bank: bankName,
                rawCoupon: coupon
            };
        } catch (error: any) {
            console.error("❌ [checkCardDiscountService] Error al consultar endpoint de cupones por BIN:", error?.response?.data || error?.message || error);
            return null;
        }
    }

    // 2. MODO SIMULADO: Retorna datos de prueba para aplicar descuento porcentual al ticket
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
        active: true,
        appliesTo: 'ticket',
        discountType: 'percentage',
        discountPercentage: 15,
        title: "Descuento en Ticket",
        description: `15% de descuento aplicado directamente al costo del ticket (BIN ${cleanBin} - ${countryCode})`,
        bank: "Banco Promoción"
    };
};

